(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tidio-custom-launcher"] && !Shopify.designMode) return;
  try {
    (function() {
  var launcher = document.getElementById('vida-tidio-launcher');
  if (!launcher) return;

  var tidioReady = false;
  var pendingOpen = false;
  var unavailable = false;
  var maxAttempts = 30;
  var attemptDelayMs = 500;

  function getTidioApi() {
    return window.tidioChatApi;
  }

  function showLauncher() {
    if (unavailable) return;
    launcher.hidden = false;
  }

  function hideLauncher() {
    launcher.hidden = true;
  }

  function setBusy(isBusy) {
    launcher.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function markUnavailable() {
    unavailable = true;
    launcher.classList.add('is-unavailable');
    launcher.setAttribute('aria-label', 'Chat is currently unavailable');
    setBusy(false);
    showLauncher();
  }

  function hideDefaultWidget() {
    var api = getTidioApi();
    if (!api || typeof api.hide !== 'function') return;
    api.hide();
  }

  function openChat() {
    var api = getTidioApi();
    if (!api) return false;
    if (typeof api.show === 'function') api.show();
    if (typeof api.open === 'function') api.open();
    hideLauncher();
    return true;
  }

  function bindCloseHandler() {
    var api = getTidioApi();
    if (!api || typeof api.on !== 'function') return;
    api.on('close', function() {
      hideDefaultWidget();
      showLauncher();
    });
    api.on('open', function() {
      hideLauncher();
    });
  }

  function onTidioReady() {
    if (tidioReady) return;
    tidioReady = true;
    hideDefaultWidget();
    bindCloseHandler();
    setBusy(false);
    showLauncher();
    if (pendingOpen) {
      pendingOpen = false;
      openChat();
    }
  }

  function waitForTidio(attemptsLeft) {
    if (getTidioApi()) {
      onTidioReady();
      return;
    }
    if (attemptsLeft <= 0) {
      markUnavailable();
      return;
    }
    setTimeout(function() {
      waitForTidio(attemptsLeft - 1);
    }, attemptDelayMs);
  }

  function registerReadyListener() {
    var api = getTidioApi();
    if (api && typeof api.on === 'function') {
      api.on('ready', onTidioReady);
      return;
    }
    document.addEventListener('tidioChat-ready', onTidioReady, { once: true });
  }

  function requestOpenChat() {
    if (unavailable) return;
    if (tidioReady) {
      openChat();
      return;
    }
    pendingOpen = true;
    setBusy(true);
    if (getTidioApi()) {
      onTidioReady();
      return;
    }
    waitForTidio(maxAttempts);
  }

  launcher.addEventListener('click', requestOpenChat);

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-vida-trigger]');
    if (!trigger) return;
    event.preventDefault();
    requestOpenChat();
  });

  window.openVidaChat = requestOpenChat;

  function checkAutoOpenFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('vida') === 'open' || params.get('open-chat') === 'true') {
        requestOpenChat();
      }
    } catch (e) {
      /* URLSearchParams unavailable — skip auto-open */
    }
  }

  registerReadyListener();
  waitForTidio(maxAttempts);
  checkAutoOpenFromUrl();
})();
  } catch(e) { console.error(e); }
})();

})();
